<template>
	<div style="font-family: siyuan;">
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="发型师档案" name="first">
				<div style="">
					<el-row>
						<el-col :span="3">
							<div class="flex">
								<div class="blue"></div>
								<div class="title">发型师档案</div>
							</div>
						</el-col>
						<el-col :span="1" style="float: right; margin-right: 20px;">
							<el-popover trigger="hover" placement="top-start" title="计算公式" width="500"
								content="业绩完成率% * 80+(会员达标)20分+(会员附加)10分+(业绩附加)10分">
								<el-button slot="reference" @click="onload" size="small">
									<i class="el-icon-refresh"></i> 刷 新
								</el-button>
							</el-popover>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="top" :span="24">
							<el-col class="t" :span="1">月份</el-col>
							<el-col :span="4">
								<el-date-picker @change="getFilelist()" value-format="yyyy-MM" size="small"
									v-model="filter.month" style="width: 150px;" type="month" placeholder="选择月">
								</el-date-picker>
							</el-col>
							<el-col class="t" :span="1">门店</el-col>
							<el-col :span="4">
								<el-select @change="getFilelist()" v-model="filter.storeId" placeholder="全部门店" clearable
									style="width: 160px;margin-right:10px;" size="small">
									<el-option-group label="营业门店" class="store">
										<el-option v-for="item in storeList" :key="item.id" :label="item.title"
											:value="item.id">
										</el-option>
									</el-option-group>
									<el-option-group label="结业门店">
										<el-option v-for="item in storeEnd" :key="item.id" :label="item.title"
											:value="item.id">
										</el-option>
									</el-option-group>
									</el-option>
								</el-select>
							</el-col>
							<el-col class="t" :span="1">职能</el-col>
							<el-col :span="4">
								<el-select v-model="filter.type" size="small" @change="getFilelist()" placeholder="职位"
									style="width: 120px" clearable>
									<el-option label="店员" value="0"></el-option>
									<el-option label="店长" value="1"></el-option>
								</el-select>
							</el-col>
							<!-- <el-col class="t" :span="1">等级</el-col>
								<el-col :span="4">
									<el-select v-model="level" size="small" @change="getFilelist()"
										style="width: 180px;margin-right:10px;" placeholder="全部">
										<el-option v-for="item in options" :key="item.label" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-col> -->
							<el-col :span="3" style="float: right;">
								<el-button type="primary" @click="getFilelist" size="small">筛 选</el-button>
								<el-button type="infor" @click="export01()" size="small">导 出</el-button>
							</el-col>
						</el-col>
					</el-row>
					<div class="hairlist" v-loading="loading">
						<el-table :data="list" style="width: 100%"
							:header-cell-style="{background:'#F2F2F4', 'text-align':'center'}"
							:cell-style="{'text-align':'center'}">
							<el-table-column prop="workerName" label="发型师" />
							<el-table-column label="门店" width='200'>
								<template slot-scope="{row}">
									<!-- {{row.storeInfo}} -->
									<div v-for="item in row.storeInfo" :key="item.index">
										{{item.storeName}}
									</div>
								</template>
							</el-table-column>
							<el-table-column label="业绩">
								<template slot-scope="{row}">
									{{row.total/100}}
								</template>
							</el-table-column>
							<el-table-column prop="turnoverRate" label="达标率" sortable>
								<template slot-scope="{row}">
									{{row.turnoverRate}}%
								</template>
							</el-table-column>
							<el-table-column prop="monthRate" label="月同比" sortable>
								<template slot-scope="{row}">
									{{row.monthRate?row.monthRate:0}}%
								</template>
							</el-table-column>
							<el-table-column label="权益新/老客数">
								<template slot-scope="{row}">
									{{row.newMember}}/{{row.oldMember}}
								</template>
							</el-table-column>
							<el-table-column label="剪发新/老客数">
								<template slot-scope="{row}">
									{{row.newHair}}/{{row.oldHair}}
								</template>
							</el-table-column>
							<el-table-column prop="avgServiceTime" label="平均服务时长" sortable />
							<el-table-column prop="level" label="级别" />
							<el-table-column label="操作">
								<template slot-scope="{row}">
									<el-button type="text" @click="workerFileDetail(row.workerId)"
										size="small">详情</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<!-- <div class="pagewai" style="text-align: center;">
							<div class="paging">
								<el-pagination @current-change="handlePageChange" @size-change="handleSizeChange2" background
									layout="sizes,prev, pager, next" :page-count="pageNo" :page-sizes="[10, 20, 30, 50, 100]"
									:page-size="pageSize" :total="total">
								</el-pagination>
							</div>
						</div> -->
				</div>
			</el-tab-pane>
			<el-tab-pane label="发型师数据" name="second">
				<div class="father">
					选择门店
					<el-select v-model="sendData.storeId" placeholder="全部门店" clearable style="margin-left: 10px;">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						</el-option>
					</el-select>
					<span style="margin-left: 20px;">选择时间</span>
					<el-date-picker v-model="sendData.time" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" clearable style="margin-left: 10px;">
					</el-date-picker>
					<el-button @click="getList()" type="primary" style="margin-left: 20px;">筛选</el-button>
					<el-button @click="reLoad()">重置</el-button>
					<el-button @click="expore()">导出</el-button>
					</el-form>
					<div style="margin-top: 10px; width: 100%;">
						<el-table stripe show-summary :data="tableData" :cell-style="{'font-size':'16px'}"
							empty-text="今天暂无订单"
							:header-cell-style="{'text-align': 'center','font-size': '20px', 'font-weight': '800', background: '#eeeeee','color':'#646464'}"
							style="text-align: center; font-family: siyuan;">
							<el-table-column prop="storeName" sortable label="门店" align="center"></el-table-column>
							<el-table-column prop="workerName" sortable label="发型师" align="center"></el-table-column>
							<el-table-column prop="num" sortable label="客数" align="center"></el-table-column>
							<el-table-column prop="first" sortable label="首次消费" align="center"></el-table-column>
							<el-table-column prop="shengKe" sortable label="生客" align="center"></el-table-column>
							<el-table-column prop="shuKe" sortable label="熟客" align="center"></el-table-column>
							<el-table-column prop="shenDu" sortable label="深度熟客" align="center"></el-table-column>
							<el-table-column prop="qiYe" sortable label="企业剪" align="center"></el-table-column>
							<!-- <el-table-column label="非会员">
									<!-- <el-table-column label="非会员">
											<el-table-column label="客数"></el-table-column>
											<el-table-column label="首次消费"></el-table-column>
											<el-table-column label="生客"></el-table-column>
											<el-table-column label="熟客"></el-table-column>
											<el-table-column label="深度熟客"></el-table-column>
										</el-table-column>
										<el-table-column label="会员">
											<el-table-column label="客数"></el-table-column>
											<el-table-column label="首次消费"></el-table-column>
											<el-table-column label="生客"></el-table-column>
											<el-table-column label="熟客"></el-table-column>
											<el-table-column label="深度熟客"></el-table-column>
										</el-table-column> -->
						</el-table>
					</div>
				</div>
			</el-tab-pane>
			<el-tab-pane label="发型师耗时" name="third">
				<div class="father">
					选择门店
					<el-select v-model="sendData2.storeId" placeholder="全部门店" clearable style="margin-left: 10px;">
						<el-option-group label="营业门店" class="store">
							<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						<el-option-group label="结业门店">
							<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-option-group>
						</el-option>
					</el-select>
					<span style="margin-left: 20px;">选择时间</span>
					<el-date-picker v-model="sendData2.time" type="daterange" value-format="yyyy-MM-dd"
						range-separator="至" clearable style="margin-left: 10px;">
					</el-date-picker>
					<el-button @click="handleButtonClick()" type="primary" style="margin-left: 20px;">筛选</el-button>
					<el-button @click="reLoad()">重置</el-button>
					<el-button @click="expore02()">导出</el-button>
					</el-form>
					<div style="margin-top: 10px; width: 100%;">
						<el-table stripe :data="tableData3" :cell-style="{'font-size':'16px','font-family': 'siyuan'}"
							empty-text="今天暂无订单"
							:header-cell-style="{'text-align': 'center','font-size': '20px', 'font-weight': '800', background: '#eeeeee','color':'#646464','font-family': 'siyuan'}"
							style="text-align: center; font-family: siyuan;">
							<el-table-column prop="storeName" sortable label="门店" align="center"></el-table-column>
							<el-table-column prop="workerName" sortable label="发型师" align="center"></el-table-column>
							<el-table-column prop="num" sortable label="实际订单数" align="center"></el-table-column>
							<el-table-column prop="numSum" sortable label="统计订单数" align="center"></el-table-column>
							<el-table-column prop="avgWaitTime" sortable label="平均等待耗时"
								align="center"></el-table-column>
							<el-table-column prop="avgHairCutTime" sortable label="平均服务耗时"
								align="center"></el-table-column>
							<el-table-column prop="avgWholeTime" sortable label="平均整单耗时"
								align="center"></el-table-column>
						</el-table>
					</div>
					<div style="margin-top: 10px; width: 100%;">
						<el-table stripe :data="tableData4" :cell-style="{'font-size':'16px','font-family': 'siyuan'}"
							empty-text="今天暂无订单"
							:header-cell-style="{'text-align': 'center','font-size': '20px', 'font-weight': '800', background: '#eeeeee','color':'#646464','font-family': 'siyuan'}"
							style="text-align: center; font-family: siyuan;">
							<el-table-column prop="avgWaitTimeTotal" sortable label="总平均等待耗时" align="center">
							</el-table-column>
							<el-table-column prop="avgHairCutTimeTotal" sortable label="总平均服务耗时" align="center">
							</el-table-column>
							<el-table-column prop="avgWholeTimeTotal" sortable label="总平均整单耗时" align="center">
							</el-table-column>
						</el-table>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>
<script>
	// import upload from "../compents/upload/upload";
	import {
		url
	} from '../../utils/index.js'
	// import{
	// 	hairFile
	// }from './hairfilesNew'
	export default {
		// components: {
		// 	hairFile
		// },
		data() {
			return {
				activeName: 'first',
				url: url(),
				tableData: [],
				tableData2: [],
				total: 0,
				tableData3: [],
				tableData4: [{
					avgWaitTimeTotal: '',
					avgHairCutTimeTotal: '',
					avgWholeTimeTotal: ''
				}],
				storeList: [],
				storeEnd: [],
				sendData: {
					storeId: '',
					time: [],
					startTime: '',
					endTime: ''
				},
				// 发型师耗时查询参数
				sendData2: {
					storeId: '',
					time: [],
					startTime: '',
					endTime: '',
					page: 1,
					size: 10,
					total: 0,
				},
				//发型师档案
				hiarlist: [],
				list: [],
				filter: {
					month: '',
					workerName: "",
					storeId: "",
					type: ''
				},
				fileTableData: [],
				serviceList: [],
				pageNo: 1,
				pageSize: 50,
				level: '',
				loading: false,
				options: [{
						value: "",
						label: "全部"
					}, {
						value: "S",
						label: "S"
					}, {
						value: "A",
						label: "A"
					}, {
						value: "B",
						label: "B"
					},
					//2022-11-02修改70以下为D
					// {
					// 	value: "C",
					// 	label: "C"
					// },
					{
						value: "D",
						label: "D"
					}
				],
			}
		},
		mounted() {
			const date1 = new Date()
			const nowDay =
				`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}`
			this.filter.month = nowDay
			this.Loading();
			// this.getList();
			this.getStores();
			// this.getTimeList();
			this.getTimeAvgList();
			this.getFilelist()
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			onload() {
				location.reload()
			},
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			Loading() {
				const date1 = new Date()
				const nowDay =
					`${date1.getFullYear()}-${date1.getMonth() + 1 < 10 ? `0${date1.getMonth() + 1}` : date1.getMonth() + 1}-${date1.getDate() < 10 ? `0${date1.getDate()}` : date1.getDate()}`
				this.sendData.time.push(nowDay); //插入开始时间
				this.sendData.time.push(nowDay); //插入结束时间
				this.sendData2.time.push(nowDay); //插入开始时间
				this.sendData2.time.push(nowDay); //插入结束时间
				this.getList()
				// this.getTimeList()
				this.getTimeAvgList()
				this.getTimeAvgListTotal()
			},
			//获取发型师数据
			getList() {
				var a = {
					startTime: this.sendData.time[0],
					endTime: this.sendData.time[1],
					storeId: this.sendData.storeId
				}
				this.$http.post("data/workerData", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.tableData = res.body.data
					}
				})
			},
			workerFileDetail(workerId) {
				console.log(workerId)
				localStorage.setItem('workerId', workerId)
				localStorage.setItem('month', this.filter.month)
				this.$router.push({
					path: '/workerFileDetail',
				})
				// var a = {
				// 		startTime: this.sendData.time[0],
				// 		endTime: this.sendData.time[1],
				// 		workerId: workerId
				// 	}
				// 	this.$http.post("data/workerData", JSON.stringify(a)).then(res => {
				// 		if (res.body.code == 200) {
				// 			this.tableData = res.body.data
				// 		}
				// 	})
				// },
			},
			// 导出发型师数据
			expore() {
				window.location.assign(this.url + "data/exportworkerData" +
					"?startTime=" + this.sendData.time[0] +
					"&endTime=" + this.sendData.time[1] +
					"&storeId=" + this.sendData.storeId
				)
			},
			//导出发型师耗时
			expore02() {
				window.location.assign(this.url + "data/exportworkerServiceTimeAvg" +
					"?startTime=" + this.sendData2.time[0] +
					"&endTime=" + this.sendData2.time[1] +
					"&storeId=" + this.sendData2.storeId
				)
			},
			// 发型师耗时
			// getTimeList() {
			// 	var a = {
			// 		startTime: this.sendData2.time[0],
			// 		endTime: this.sendData2.time[1],
			// 		storeId: this.sendData2.storeId,
			// 		pageNum: this.sendData2.page,
			// 		pageSize: this.sendData2.size
			// 	}
			// 	this.$http.post("data/workerServiceTime", JSON.stringify(a)).then(res => {
			// 		if (res.body.code == 200) {
			// 			this.tableData2 = res.body.data
			// 			this.sendData2.total = res.body.total
			// 		}
			// 	})
			// },
			// 发型师平均耗时
			getTimeAvgList() {
				var a = {
					startTime: this.sendData2.time[0],
					endTime: this.sendData2.time[1],
					storeId: this.sendData2.storeId
				}
				this.$http.post("data/workerServiceTimeAvg", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						this.tableData3 = res.body.data
						console.log(this.tableData3)
					}
				})
			},
			// 总---发型师平均耗时
			getTimeAvgListTotal() {
				var a = {
					startTime: this.sendData2.time[0],
					endTime: this.sendData2.time[1],
					storeId: this.sendData2.storeId
				}
				this.$http.post("data/workerServiceTimeAvgTotal", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						var a = res.body.data
						this.tableData4[0].avgWaitTimeTotal = a.avgWaitTimeTotal
						this.tableData4[0].avgHairCutTimeTotal = a.avgHairCutTimeTotal
						this.tableData4[0].avgWholeTimeTotal = a.avgWholeTimeTotal
					}
				})
			},
			//发型师档案
			getFilelist() {
				// document.cookie = "storeId=" + escape(JSON.stringify(this.filter.storeId));
				this.loading = true
				var a = "?month=" + this.filter.month +
					"&workerId=" + this.filter.workerName +
					"&storeId=" + this.filter.storeId +
					// "&pageNum=" + this.pageNo +
					"&type=" + this.filter.type +
					// "&pageSize=" + this.pageSize +
					"&level=" + this.level + "&content=scoreDesc"
				this.$http.get("dWorkerFile/list" + a).then(res => {
					var list = res.body.data
					for (let i in list) {
						list[i].avgServiceTime2 = list[i].avgServiceTime.split(":")[1]
						list[i].storeInfo = JSON.parse(list[i].storeInfo)
					}
					this.list = list
					this.total = res.body.total
					this.loading = false
				})
			},
			godeatil(e) {
				// 保存数据
				localStorage.setItem('hairuser', JSON.stringify(e))
				this.$router.push({
					path: '/hairfilesdetail',
					query: {
						id: e.workerId
					}
				})
			},
			// 导出发型师档案
			export01() {
				var a = "?month=" + this.filter.month +
					"&workerId=" + this.filter.workerName +
					"&storeId=" + this.filter.storeId +
					"&type=" + this.filter.type +
					// "&pageNum=" + this.pageNo +
					// "&pageSize=" + this.pageSize +
					"&level=" + this.level
				window.location.assign(this.url + "dWorkerFile/exportWorkerFile" + a)
			},
			// getWorkerList() {
			// this.loading = true
			// var query = "page=" + this.form.page + "&size=" + this.form.size;
			// if (this.form.name.trim().length > 0) query += "&name=" + this.form.name;
			// if (this.form.shop != "") query += "&storeId=" + this.form.shop;
			// if (this.form.state != "") query += "&status=" + this.form.state;
			// if (this.form.type != "") query += "&type=" + this.form.type;
			// if (this.form.isRemove != ""||this.form.isRemove != null) query += "&isRemove=" + this.form.isRemove
			// if (this.form.value != "" && this.form.value != null) query += "&joinTime=" + this.form.value;
			// this.$http.get("dWorker/queryAll?" + query).then(res => {
			// 	console.log(res)
			// 	this.form.page = res.body.data.current;
			// 	this.form.size = res.body.data.size;
			// 	this.form.total = res.body.data.total;
			// 	this.workList = res.body.data.records.filter(e => e.test==0);
			// 	this.workTestList = res.body.data.records.filter(e => e.test==1);
			// 	this.loading = false
			// });
			// },
			handlePageChange(val) {
				this.pageNo = val
				this.getFilelist()
			},
			handleSizeChange2(val) {
				this.pageSize = val
				this.getFilelist()
			},
			handleCurrentChange(val) {
				this.sendData2.page = val;
				this.getTimeList()
			},
			handleSizeChange(val) {
				this.sendData2.size = val;
				this.getTimeList()
			},
			handleButtonClick() {
				// this.getTimeList()
				this.getTimeAvgList()
				this.getTimeAvgListTotal()
			},
			reLoad() {
				this.sendData = {
					storeId: '',
					time: [],
					startTime: '',
					endTime: ''
				}
				this.sendData2 = {
						storeId: '',
						time: [],
						startTime: '',
						endTime: '',
						page: 1,
						size: 10,
						total: 0,
					},
					this.Loading()
				// this.getList()
			},
		}
	}
</script>
<style scoped="scoped" lang="less">
	.waititle {
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.flex {
		display: flex;
	}

	.t {
		margin-top: 3px;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;
	}

	.blue {
		width: 5px;
		height: 15px;
		background: #409EFF;
		border-radius: 2px;
		margin-right: 8px;
		position: relative;
		top: 4px;
	}

	.top {
		width: 98%;
		height: 67px;
		background: #FFFFFF;
		box-shadow: 2px 2px 4px 2px rgba(147, 147, 147, 0.5);
		border-radius: 5px;
		box-sizing: border-box;
		margin: 20px 20px 10px 5px;
		padding: 20px 10px 10px 10px;
	}

	// 发型师列表
	.hairlist {
		// padding-right: 10px;
		margin-left: -5px;
		min-height: 100px;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		margin-top: 20px;

		.list {
			width: 24.5%;
			margin-left: 5px;
			// margin-right: 1.2%;
			margin-bottom: 18px;
			height: 140px;
			background: #FFFFFF;
			// box-shadow: 0px 5px 5px 5px rgba(187, 186, 186, 0.5);
			box-shadow: 1px 5px 5px 2px #e8e8e8;
			border-radius: 8px;
			border: 1px solid #dcdcdc;
			box-sizing: border-box;
			padding: 5px;

			.listtop {
				display: flex;

				.headlike {
					width: 75px;
					height: 75px;
					margin-left: 1%;
					border-radius: 50%;
					overflow: hidden;

					>img {
						width: 100%;
						height: 100%;
					}
				}

				.message {
					padding-left: 8%;
					flex: 1;

					>div:nth-child(1) {
						font-size: 18px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #2D2D2D;
					}

					>div:nth-child(2) {
						width: 75px;
						height: 18px;
						background: #00B648;
						border-radius: 2px;
						border: 0px solid #979797;
						font-size: 14px;
						font-family: SourceHanSansCN;
						color: #FFFFFF;
						line-height: 9px;
						text-align: center;
						line-height: 15px;
						margin-top: 5px;
						padding-top: 3px;
					}

					>div:nth-child(3) {
						width: 120px;
						font-size: 12px;
						font-family: SourceHanSansCN;
						color: #333333;
						margin-top: 5px;
					}
				}

				.garde {
					width: 80px;
					text-align: center;

					>div:nth-child(1) {
						font-size: 28px;
						font-family: SourceHanSansCN-Bold, SourceHanSansCN;
						font-weight: bold;
						color: #FF0000;
						line-height: 36px;
					}
				}
			}

			// 
			.listbottom {
				display: flex;
				width: 100%;
				margin-top: 10px;
				margin-left: -5px;

				>.listbottom_s1 {
					width: 18%;
					font-size: 14px;
					text-align: center;
				}

				>.listbottom_s0 {
					width: 23%;
					font-size: 14px;
					text-align: center;
					//       flex: 1;
					// >div:nth-child(1){
					// 	display: realtive;
					// 	width: 80px;
					// 	margin-left:-8px;
					// 	// transform: scale(0.7);
					// }
				}

				>.listbottom_s2 {
					width: 33%;
					font-size: 14px;
					text-align: center;
				}

				>.listbottom_s {
					width: 27%;
					font-size: 14px;
					text-align: center;
				}

				.border {
					width: 1px;
					height: 35px;
					font-size: 8px;
					background: #ababab;
					margin: 2px 1px;

				}
			}

			// 
		}

		// >.list:nth-child(5n){
		// 	margin-right: 0;
		// }
	}
</style>